import { withT } from "neetocommons/react-utils";
import { Right } from "neetoicons";
import { Dropdown } from "neetoui";

const { MenuItem } = Dropdown;

const MenuButton = withT(({ t }) => (
  <MenuItem.Button
    className="neeto-molecules-menu-sublist__item-btn"
    data-testid="organization-switcher-button"
    style="text"
    suffix={<Right className="rtl:scale-x-[-1]" size={18} />}
  >
    {t("neetoMolecules.sidebar.organizationSwitcher.label")}
  </MenuItem.Button>
));

export default MenuButton;
